import { CREATED_AT } from 'shared/api/query/constants';
import { DateTime } from 'luxon';
import { sortByAttr, sortChain, sortDatetime, sortReverse } from 'shared/lib/sort';

export const chatGroup = {
  pinned: 'pinned',
  today: 'today',
  yesterday: 'yesterday',
  previous30Days: 'previous30Days',
  older: 'older',
};

const groupOrder = [chatGroup.pinned, chatGroup.today, chatGroup.yesterday, chatGroup.previous30Days, chatGroup.older];

export const isPinned = (chat) => typeof chat?.pinnedAt === 'string';

const byPinTime = sortReverse(sortByAttr('pinnedAt', sortDatetime));

const groupOf = (created, startOfToday) => {
  if (created === null) {
    return chatGroup.today;
  }
  const at = DateTime.fromISO(created);
  if (at >= startOfToday) {
    return chatGroup.today;
  }
  if (at >= startOfToday.minus({ days: 1 })) {
    return chatGroup.yesterday;
  }
  if (at >= startOfToday.minus({ days: 30 })) {
    return chatGroup.previous30Days;
  }
  return chatGroup.older;
};

const withCreated = (chat) => ({ chat, created: DateTime.fromISO(chat[CREATED_AT]).isValid ? chat[CREATED_AT] : null });

// a chat with no usable createdAt has just been created locally, so it sorts newest
const byRecency = sortChain([
  (a, b) => Number(a.created !== null) - Number(b.created !== null),
  sortReverse(sortByAttr('created', sortDatetime)),
]);

export const groupChatsByRecency = (chats, now = DateTime.local()) => {
  const startOfToday = now.startOf('day');
  const buckets = new Map(groupOrder.map((key) => [key, []]));
  buckets.set(chatGroup.pinned, chats.filter(isPinned).sort(byPinTime));

  chats
    .filter((chat) => !isPinned(chat))
    .map(withCreated)
    .sort(byRecency)
    .forEach(({ chat, created }) => { buckets.get(groupOf(created, startOfToday)).push(chat); });

  return groupOrder
    .map((key) => ({ key, chats: buckets.get(key) }))
    .filter(({ chats: grouped }) => grouped.length > 0);
};

export const chatTitle = (chat, untitled) => {
  const title = chat?.title;
  return typeof title === 'string' && title.trim() !== '' ? title : untitled;
};
